import { Code2, ShoppingBag } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const features = [
  {
    title: "Powerful API",
    description:
      "RESTful API with comprehensive documentation and SDKs for major programming languages.",
    icon: Code2,
  },
  {
    title: "Shopify Web App",
    description:
      "Native Shopify integration that seamlessly connects with your store's product catalog.",
    icon: ShoppingBag,
  },
];

export const Features = () => {
  return (
    <section className="py-24 bg-skuhub-navy/95">
      <div className="container px-4 mx-auto">
        <h2 className="mb-12 text-4xl font-bold text-center text-white">
          Why Choose SkuHub?
        </h2>
        <div className="grid gap-8 md:grid-cols-2">
          {features.map((feature) => (
            <Card
              key={feature.title}
              className="bg-white/5 border-white/10 backdrop-blur-sm transition-transform hover:-translate-y-1"
            >
              <CardHeader>
                <feature.icon className="w-12 h-12 mb-4 text-skuhub-coral" />
                <CardTitle className="text-white">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-300">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};